import { NavLink } from "react-router-dom";
import { navItems } from "@/constants/miscConstants";
import { useTranslation } from "react-i18next";
import { v4 as uuidv4 } from "uuid";

const MenuItems = ({ handleNav, isMobile, handleClick }) => {
  const { t } = useTranslation();

  return (
    <>
      {navItems.map((item) => {
        if (!isMobile && item.name === "listingProperty.breadcrumbHome")
          return null;

        const onClick = (e) => {
          if (handleClick) {
            handleClick(e, item);
          }
          handleNav?.();
        };

        return (
          <NavLink
            key={uuidv4()}
            onClick={onClick}
            className={`z-10 flex items-center gap-3 px-4 py-3 transition-all duration-300 ${
              isMobile
                ? "text-[#0F0F0F] px-5 font-semibold hover:bg-gray-100 hover:text-[#0F0F0F]"
                : "px-5 capitalize rounded-full bg-[#7B9E7E1F] text-[#32493B] hover:text-primary text-sm font-bold"
            }`}
            to={item.to}>
            {item.icon && isMobile && (
              <span className="text-xl">{item.icon}</span>
            )}
            <span>{t(item.name)}</span>
          </NavLink>
        );
      })}
    </>
  );
};

export default MenuItems;
